import { apiService } from "./base-api-service";
import { endPoints, getJobManagerServiceEndPoint } from "./api-constants";

class JobManagerService {
  JobManagerService(url) {
    return getJobManagerServiceEndPoint(url);
  }

  getJobStatus(opId) {
    //opId = opId.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
    const endpoint = this.JobManagerService(`${endPoints.jobManagerService.JOB_STATUS.replace(":operationId", opId)}`);
    return apiService.get(endpoint);
  }
}

export default new JobManagerService();
